import React from "react";
import { BooleanField } from "./PlannerFields";

export default function FinalisationClosureTile({
  planner,
  setFinalisationField,
}) {
  return (
    <section className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden border-t-4 border-t-purple-600 flex flex-col h-full">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <h2 className="text-lg font-bold text-slate-800">Finalisation and Closure</h2>
        <div className="text-slate-300">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
          </svg>
        </div>
      </div>

      <div className="p-5 flex-1 space-y-4">
        <div className="grid grid-cols-1 gap-4">
          <BooleanField
            label="Matter finalised?"
            value={planner.finalisation.matterFinalised}
            onChange={(value) => setFinalisationField("matterFinalised", value)}
          />
          <BooleanField
            label="Outcome entered in ATLAS?"
            value={planner.finalisation.outcomeEnteredInAtlas}
            onChange={(value) => setFinalisationField("outcomeEnteredInAtlas", value)}
          />
          <BooleanField
            label="Grant closed?"
            value={planner.finalisation.grantClosed}
            onChange={(value) => setFinalisationField("grantClosed", value)}
          />
          <label className="space-y-1 text-sm block">
            <span className="font-medium text-slate-700">Closure date</span>
            <input
              type="date"
              value={planner.finalisation.closureDate || ""}
              onChange={(e) => setFinalisationField("closureDate", e.target.value)}
              className="h-10 w-full rounded-lg border border-slate-200 px-3 focus:border-purple-500 outline-none transition-all"
            />
          </label>
        </div>
      </div>
    </section>
  );
}
